/**
 * Client-side application settings for the local development environment.
 */
export const defaultConfig = {
  // Core application settings
  app: {
    name: 'My Account',
    host: process.env.CONFIG_APP_HOST || 'local.lawpilots.eu:3000',
    env: 'local' as 'local' | 'test' | 'production' | 'development',
  },
  // API and Auth endpoint(s)
  api: {
    origin: process.env.CONFIG_API_ORIGIN || 'http://api.local.lawpilots.eu:8012',
    path: '/api',
    prefix: '/tenant',
    subdomain: '/subdomain',
    redirect_url: process.env.CONFIG_API_REDIRECT_URL || 'http://local.lawpilots.eu:3000',
  },
  // Local development does not connect to LaunchDarkly; the deployed environments set their id.
  launchDarkly: {
    clientSideId: '',
  },
  integration: {
    origin: process.env.CONFIG_INTEGRATION_SCIM_ORIGIN || 'http://api.local.lawpilots.eu:8012/scim',
    origin_webhook_integration:
      process.env.CONFIG_INTEGRATION_WEBHOOK_ORIGIN || 'http://api.local.lawpilots.eu:8012/webhook-integration',
  },
  // Feature flags
  features: {
    enableIntegrationsTab: true,
    enableGlobalAdminSidebar: true,
  },
}

/**
 * Client-side application settings for the test environment.
 */
export const test: typeof defaultConfig = {
  app: {
    ...defaultConfig.app,
    host: 'lawpilots.eu',
    env: 'test',
  },
  api: {
    ...defaultConfig.api,
    origin: 'https://api.lawpilots.eu',
    redirect_url: 'https://lawpilots.eu',
  },
  launchDarkly: {
    ...defaultConfig.launchDarkly,
    clientSideId: process.env.LAUNCHDARKLY_STAGE_CLIENT_ID || defaultConfig.launchDarkly.clientSideId,
  },
  integration: {
    origin: 'https://api.lawpilots.eu/scim',
    origin_webhook_integration: 'https://api.lawpilots.eu/webhook-integration',
  },
  features: {
    enableIntegrationsTab: true,
    enableGlobalAdminSidebar: true,
  },
}

/**
 * Client-side application settings for the production environment.
 */
export const production: typeof defaultConfig = {
  app: {
    ...defaultConfig.app,
    host: 'lawpilots.net',
    env: 'production',
  },
  api: {
    ...defaultConfig.api,
    origin: 'https://api.lawpilots.net',
    redirect_url: 'https://lawpilots.net',
  },
  launchDarkly: {
    ...defaultConfig.launchDarkly,
    clientSideId: process.env.LAUNCHDARKLY_PROD_CLIENT_ID || defaultConfig.launchDarkly.clientSideId,
  },
  integration: {
    ...defaultConfig.integration,
    origin: 'https://api.lawpilots.net/scim',
    origin_webhook_integration: 'https://api.lawpilots.net/webhook-integration',
  },
  features: {
    enableIntegrationsTab: true,
    enableGlobalAdminSidebar: true,
  },
}

/**
 * Client-side application settings for the development environment.
 */

export const development: typeof defaultConfig = {
  app: {
    ...defaultConfig.app,
    host: 'lawpilots.dev',
    env: 'development',
  },
  api: {
    ...defaultConfig.api,
    origin: 'https://api.lawpilots.dev',
    redirect_url: 'https://lawpilots.dev',
  },
  launchDarkly: {
    ...defaultConfig.launchDarkly,
    clientSideId: process.env.LAUNCHDARKLY_STAGE_CLIENT_ID || defaultConfig.launchDarkly.clientSideId,
  },
  integration: {
    origin: 'https://api.lawpilots.dev/scim',
    origin_webhook_integration: 'https://api.lawpilots.dev/webhook-integration',
  },
  features: {
    enableIntegrationsTab: true,
    enableGlobalAdminSidebar: true,
  },
}

export type Config = typeof defaultConfig
export default { defaultConfig, test, development, production }
